/**
 * 课前诊断「打印题单」:把本次诊断的题目(含配图)拼成一页可打印的
 * 自包含 HTML,学生纸上作答,老师批改后再拍照识别/手工录入。
 * 和作业单 homeworkSheet.ts 同一套路:模板拼版,不再调模型。
 */

import type { ItargetQuestion } from "../../api/school";
import { mathToHtml } from "../../lib/mathText";
import { FIGURE_CSS, figureHtml, safeSvg } from "../../lib/safeSvg";

function esc(s: string): string {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function renderItargetSheetHtml(
  questions: ItargetQuestion[],
  meta: { topic: string; date?: string; className?: string },
): string {
  let figNo = 0;
  const body = [...questions]
    .sort((a, b) => a.id - b.id)
    .map((q) => {
      const svg = safeSvg(q.figure_svg);
      const fig = svg ? figureHtml(svg, `图${++figNo}`) : "";
      const roomy = q.type !== "multiple_choice" && q.type !== "true_false";
      return `<li class="q"><div class="stem">${mathToHtml(q.question, { breaks: true })}</div>${fig}${
        roomy ? '<div class="space"></div>' : '<div class="ans">答：________</div>'
      }</li>`;
    })
    .join("");
  const subtitle = [meta.className, meta.date].filter(Boolean).join(" · ");
  const title = `课前诊断 · ${meta.topic}`;
  return `<!DOCTYPE html><html lang="zh-CN"><head><meta charset="utf-8">
<title>${esc(title)}</title>
<style>
  body { font-family: -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif;
         max-width: 760px; margin: 0 auto; padding: 32px 24px; color: #1e293b; line-height: 1.7; }
  h1 { font-size: 20px; margin: 0 0 4px; }
  .sub { color: #64748b; font-size: 13px; margin-bottom: 16px; }
  .name-row { display: flex; gap: 32px; font-size: 14px; color: #475569;
              border-bottom: 1px solid #e2e8f0; padding-bottom: 12px; margin-bottom: 20px; }
  ol.qs { padding-left: 22px; }
  li.q { margin-bottom: 18px; page-break-inside: avoid; break-inside: avoid; }
  .stem { font-size: 15px; }
  math { font-size: 1.05em; }
  .ans { font-size: 14px; color: #475569; margin-top: 6px; }
  .space { border-bottom: 1px solid #cbd5e1; height: 44px; margin-top: 8px; }${FIGURE_CSS}
</style></head><body>
<h1>${esc(title)}</h1>
${subtitle ? `<div class="sub">${esc(subtitle)}</div>` : ""}
<div class="name-row"><span>姓名：____________</span><span>班级：____________</span></div>
<ol class="qs">${body}</ol>
</body></html>`;
}

/** 同源 blob 直接开新标签页;不加 noopener(见 window-open-noopener 的坑)。 */
export function openItargetSheet(questions: ItargetQuestion[], meta: { topic: string; date?: string; className?: string }): void {
  const html = renderItargetSheetHtml(questions, meta);
  const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
  window.open(url, "_blank");
}
